import { PUSH_NOTIFICATION, DELETE_NOTIFICATION } from '@/store/mutation-types'

export default {
  namespaced: true,
  state: {
    notifications: [],
    nextId: 1,
    notificationDuration: 2000,
  },

  mutations: {
    [PUSH_NOTIFICATION](state, notification) {
      state.notifications.push({
        ...notification,
        id: state.nextId,
      })
      state.nextId += 1
    },
    [DELETE_NOTIFICATION](state, notificationToRemove) {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== notificationToRemove.id,
      )
    },
  },
  actions: {
    add({ commit }, notification) {
      commit(PUSH_NOTIFICATION, notification)
    },
    remove({ commit }, notificationToRemove) {
      commit(DELETE_NOTIFICATION, notificationToRemove)
    },
  },
}
